module.exports = __webpack_public_path__ + "img/com.codeway.chatapp.37a6664d.png";